module.exports = __webpack_public_path__ + "media/images/grey-bubble-9bcdd03a6a6bdc2b4533d9757f7f8120.png";